import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export function useClearHistoryState() {
  const location = useLocation()
  const navigate = useNavigate()

  const clearHistoryState = useCallback(() => {
    if (location.state) navigate(location, { replace: true })
  }, [location, navigate])

  return { clearHistoryState }
}
